// Begin Slider 3 > 4 Tabs Functionality
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('slider3:tabs-ready', init);
  function init() {
    var rows = document.querySelectorAll('.slider-3-pattern .slider-3-slider-selector');
    rows.forEach(function (row) {
      if (row.dataset.dropdownBuilt) return;
      row.dataset.dropdownBuilt = '1';
      var wrap = document.createElement('div');
      wrap.className = 'slider-3-tabs-select-wrap';
      var select = document.createElement('select');
      select.className = 'slider-3-tabs-select';
      select.setAttribute('aria-label', 'Select slider');
      var buttons = Array.prototype.slice.call(
        row.querySelectorAll('.slider-3-slider-selector-title')
      );
      buttons.forEach(function (btn, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = btn.textContent.trim();
        if (btn.classList.contains('slider-3-slider-selector-title-active')) {
          opt.selected = true;
        }
        select.appendChild(opt);
      });
      wrap.appendChild(select);
      row.parentNode.insertBefore(wrap, row);
      select.addEventListener('change', function () {
        var idx = parseInt(select.value, 10);
        if (!isNaN(idx) && buttons[idx]) {
          buttons[idx].click();
        }
      });
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('.slider-3-slider-selector-title');
        if (!btn) return;
        var idx = buttons.indexOf(btn);
        if (idx > -1) select.value = String(idx);
      });
    });
  }
})();

(function () {
  function bindHorizontalOnly(el) {
    if (el.dataset.wheelBound) return;
    el.dataset.wheelBound = '1';
    el.addEventListener('wheel', function (e) {
      const unit = (e.deltaMode === 1) ? 16 : (e.deltaMode === 2 ? window.innerHeight : 1);
      const dx = e.deltaX * unit;
      const dy = e.deltaY * unit;
      const delta = (Math.abs(dx) > Math.abs(dy) ? dx : dy);
      const before = el.scrollLeft;
      el.scrollLeft += delta;
      const after = el.scrollLeft;
      if (after !== before) e.preventDefault();
    }, { passive: false });
  }
  function init() {
    document.querySelectorAll('.slider-3-pattern .slider-3-slider-selector')
      .forEach(bindHorizontalOnly);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('slider3:tabs-ready', init);
})();
//End Slider 3 > 4 Tabs Functionality
